import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { Swipeable } from 'react-swipeable';
import { makeStyles } from '@material-ui/styles';
import Transport from './Transport';
import { staticsUrl, baseUrl } from '../../../config';
import BackIcon from '@material-ui/icons/ArrowBackIos';
import ForwardIcon from '@material-ui/icons/ArrowForwardIos';
import historyCache from '../../../config/historyCache.json';
import { getLocalSettings } from '../../../redux/actions';
import PlayIcon from '@material-ui/icons/PlayArrow';
import StopIcon from '@material-ui/icons/Stop';

const useStyles = makeStyles(theme => ({
  frame: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'stretch',
    background: '#eee',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
  },
  imgWrap: {
    width: '100%',
    height: '100%',
    position: 'relative',
    overflow: 'hidden',
  },
  imgBack: {
    position: 'absolute',
    inset: 0,
    width: '100%',
    heigt: '100%',
    backgroundColor: '#fff',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    overflow: 'hidden',
    opacity: 0.4,
    filter: 'blur(5px)',
  },
  imgMain: {
    position: 'absolute',
    inset: 0,
    width: '100%',
    heigt: '100%',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
  },
  preloads: {
    position: 'absolute',
    top: 0,
    left: 0,
    opacity: 0.01,
    width: 1,
    height: 1,
  },
  imgNextWrap: {
    width: 1,
    height: 1,
    opacity: 0.1,
  },
  en: {
    fontWeight: 600,
    textAlign: 'center',
    fontSize: '1.35em',
    padding: '0.5em 0.5em 0 0.5em',
  },
  pl: {
    textAlign: 'center',
    fontSize: '1.35em',
    padding: '0 0.5em 0.5em 0.5em',
  },
  loadingBar: {
    height: 10,
    background: theme.palette.primary.main,
    opacity: 0.75,
    position: 'absolute',
    left: 0,
    bottom: 0,
  },
  action: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    '& > div': {
      position: 'absolute',
      top: 0,
      bottom: 0,
      width: '20%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: 'rgba(255, 255, 255, 0)',
      cursor: 'pointer',
      color: '#fff',
      opacity: 0.5,
      transition: 'all 0.3s',
      '&:hover': {
        opacity: 1,
        background: 'rgba(255, 255, 255, 0.3)',
      },
      '& svg': {
        fontSize: '3em',
      },
      '& path:first-of-type': {
        stroke: 'rgba(0, 0, 0, 0.3)',
      },
      '&:nth-child(1)': {
        left: 0,
      },
      '&:nth-child(2)': {
        right: 0,
      },
    },
  },
  playBtn: {
    top: '20%',
    left: '30%',
    bottom: '20%',
    right: '30%',
    display: 'block',
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    opacity: 0,
    '& svg': {
      color: '#fff',
      fontSize: 150,
    },
  },
  playBtn1: {
    transition: 'none',
    opacity: 1,
  },
  '@media(max-width: 850px)': {
    action: {
      '& > div': {
        '& svg': {
          fontSize: '2em',
        },
        transition: 'all 0.3s',
        '&:hover': {
          opacity: 1,
          background: 'rgba(255, 255, 255, 0)',
        },
      }
    },
    playBtn: {
      '& svg': {
        fontSize: 90,
      },
    },
    loadingBar: {
      height: 7,
    },
  },
  '@media(max-width: 500px)': {
    action: {
      '& > div': {
        display: 'none',
      }
    },
    playBtn: {
      '& svg': {
        fontSize: 60,
      },
    },
    loadingBar: {
      height: 5,
    },
  }
}));

let sliderTimeout = 0;
let styleTimeout = 0;
const keys = ['Space', 'ArrowLeft', 'ArrowRight'];

function History(props) {
  const classes = useStyles();
  const { exercise, status, progress, setSoundEnabled, keyboard } = props;
  const [no, setNo] = useState(0);
  const [fanfarePlayed, setFanfarePlayed] = useState(false);
  const [autoplay, setAutoplay] = useState(false);
  const [prevNo, setPrevNo] = useState(0);
  const [mainImgLoaded, setMainImgLoaded] = useState(false);
  const [throttle, setThrottle] = useState(false);
  const [saveBandwidth, setSaveBandwidth] = useState(false);
  const [keyPress, setKeyPress] = useState(null);
  const mounted = useRef(true);
  const playRef = useRef(null);
  const stopRef = useRef(null);
  const keyTimeoutRef = useRef(0);
  const imagesLen = exercise.length;
  const { text, translation, imageUrl } = exercise[no];
  const imageUrl1 = (no < imagesLen - 1) ? exercise[no + 1].imageUrl : imageUrl;
  const loading = progress !== 1;

  useEffect(() => {
    props.startStats(props.type);
    play();
    const localSettings = getLocalSettings();
    const { saveBandwidth } = localSettings;
    setSaveBandwidth(saveBandwidth);
    const keyboardSubscription = keyboard.subject.subscribe(handleKeyUp);
    return () => {
      keyboardSubscription.unsubscribe();
      pause();
      mounted.current = false;
      clearTimeout(sliderTimeout);
      clearTimeout(styleTimeout);
      clearTimeout(keyTimeoutRef);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!keyPress) return;
    switch (keyPress) {
      case 'Space':
        togglePlay();
        break;
      case 'ArrowLeft':
        prev();
        break;
      case 'ArrowRight':
        next();
        break;
    }
    clearTimeout(keyTimeoutRef);
    keyTimeoutRef.current = setTimeout(() => {
      if (!mounted.current) return;
      setKeyPress(null);
    }, 100);
    // eslint-disable-next-line
  }, [keyPress]);

  useEffect(() => {
    if (prevNo !== no) {
      setPrevNo(no);
      play();
    }
    // eslint-disable-next-line
  }, [no, status]);

  const handleKeyUp = (keyCode) => {
    if (keys.indexOf(keyCode) === -1) return;
    setKeyPress(keyCode);
  }

  const next = () => {
    props.action();
    if (no < props.exercise.length - 1) {
      setNo(no + 1);
    } else {
      finishExercise();
    }
    if (no === props.exercise.length - 2) {
      props.finishExercise();
    }
    setMainImgLoaded(false);
  };

  const prev = () => {
    props.action();
    setNo(Math.max(0, no - 1));
    setMainImgLoaded(false);
  }

  const restart = () => {
    props.action();
    setNo(0);
  }

  const play = () => {
    const url = props.exercise[no].soundUrl;
    props.play(url);
  };

  const pause = () => {
    setAutoplay(false);
    props.stop();
  };

  const finishExercise = () => {
    if (!fanfarePlayed) {
      setFanfarePlayed(true);
      props.media.finish();
    }
    if (props.expand) {
      props.onExpand(false);
    }
  }

  const onSliderChange = () => {
    clearTimeout(sliderTimeout);
    if (!throttle) setThrottle(true);
    if (status === 'playing') props.stop();
    sliderTimeout = setTimeout(() => {
      setThrottle(false);
    }, 500);
  }

  const togglePlay = () => {
    let icon;
    if (status === 'playing') {
      pause();
      icon = stopRef.current;
    } else {
      play();
      icon = playRef.current;
    }
    clearTimeout(styleTimeout);
    icon.style.transition = 'none';
    icon.style.opacity = 1;
    setTimeout(() => {
      if (!mounted.current) return;
      icon.style.transition = 'opacity 1s';
      icon.style.opacity = 0;
    }, 200);
  }

  const renderCurrentSlide = () => {
    const mainImgPath = `${staticsUrl + imageUrl}`;
    const mainImgStyle = { backgroundImage: `url("${mainImgPath}")` };
    let fallbackImg = historyCache[imageUrl];
    let fallbackImgPath = fallbackImg ? `${baseUrl}/resources/History/${historyCache[imageUrl]}` : staticsUrl + imageUrl;
    const fallbackStyle = { backgroundImage: `url("${fallbackImgPath}")` };
    return (
      <div className={classes.currentSlide}>
        <div className={classes.imgBack} style={fallbackStyle} />
        <div className={classes.imgMain} style={fallbackStyle} />
        {!throttle && !saveBandwidth && <div className={classes.imgMain} style={mainImgStyle} />}
      </div>
    );
  }

  const ImgFrame = () => {

    return (
      <Swipeable onSwipedRight={prev} onSwipedLeft={next} delta={40} className={classes.frame}>
        <div className={classes.imgWrap}>
          {renderCurrentSlide()}
          <div className={classes.action}>
            <div onClick={prev}><BackIcon /></div>
            <div onClick={next}><ForwardIcon /></div>
            <i className={classes.playBtn} onClick={togglePlay} ref={playRef}>
              <PlayIcon />
            </i>
            <i className={classes.playBtn} onClick={togglePlay} ref={stopRef}>
              <StopIcon />
            </i>
          </div>
          {loading && <div className={classes.loadingBar} style={{ width: `${progress * 100}%` }} />}
        </div>
        <div>
          <div className={classes.textBox}>
            <div className={classes.en}>{text}</div>
            <div className={classes.pl}>{translation}</div>
          </div>
        </div>
      </Swipeable>
    );
  }

  return (<>
    <div className={classes.preloads}>
      {!throttle && !saveBandwidth && <img src={staticsUrl + imageUrl} alt="" onLoad={() => setMainImgLoaded(true)} />}
      {mainImgLoaded && !throttle && !saveBandwidth && <img src={staticsUrl + imageUrl1} alt="" />}
    </div>
    {ImgFrame()}
    {!props.expand && <Transport
      no={no}
      setNo={(no2) => setNo(no2)}
      len={exercise.length}
      play={play}
      pause={pause}
      restart={restart}
      prev={prev}
      next={next}
      status={props.status}
      type={props.type}
      autoplay={autoplay}
      onChange={onSliderChange}
      soundEnabled={props.soundEnabled}
      setSoundEnabled={setSoundEnabled}
    />}
  </>);

}

const mapStateToProps = (state) => {
  return {
    mobile: state.mobile,
    media: state.media,
    browser: state.auth.browser.system.browser.name,
    keyboard: state.keyboard,
  }
}

export default connect(mapStateToProps)(History);
